<template>
    <div class="modal fade" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="closeModal('#' + id)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-2 mx-50 pb-5">
                    <div style="block-size: 200px;" class="card shadow-none bg-transparent border mb-1">
                        <div class="card-body">
                            <img 
                                style="object-fit: contain;position: absolute;top: 0;left: 0;width: 100%;height: 100%;"
                                class="card-img-top"
                                :src="reportStore.images.banner"
                                alt="Card image cap"
                            />
                        </div>
                    </div>
                    <div class="row match-height">
                        <div class="col-md-6 col-sm-12 pr-md-50">
                            <input
                                class="custom-option-item-check"
                                type="radio"
                                name="credit-monitoring-services"
                                id="creditfixrrreports"
                                v-model="defaultCreditMonitoringAgency"
                                :value="reportStore.creditfixrrreports"
                            />
                            <label
                                class="custom-option-item text-center p-1 bg-transparent border rounded h-100"
                                :class="{ 'border-primary': defaultCreditMonitoringAgency == reportStore.creditfixrrreports }"
                                for="creditfixrrreports"
                            >
                                <img
                                    :src="creditMonitoringAgency(reportStore.creditfixrrreports).icon"
                                    :alt="creditMonitoringAgency(reportStore.creditfixrrreports).name"
                                />
                                <p>
                                    {{ defaultCreditMonitoringAgency == reportStore.creditfixrrreports ? 'Selected' : 'Select this Option' }}
                                </p>
                            </label>
                        </div>
                        <div class="col-md-6 col-sm-12 pl-1 pl-md-0">
                            <input
                                class="custom-option-item-check"
                                type="radio"
                                name="credit-monitoring-services"
                                id="smartcredit"
                                v-model="defaultCreditMonitoringAgency"
                                :value="reportStore.smartcredit"
                            />
                            <label
                                class="custom-option-item text-center p-1 bg-transparent border rounded h-100"
                                :class="{ 'border-primary': defaultCreditMonitoringAgency == reportStore.smartcredit }"
                                for="smartcredit"
                            >
                                <img
                                    :src="creditMonitoringAgency(reportStore.smartcredit).icon"
                                    :alt="creditMonitoringAgency(reportStore.smartcredit).name"
                                />
                                <p>
                                    {{ defaultCreditMonitoringAgency == reportStore.smartcredit ? 'Selected' : 'Select this Option' }}
                                </p>
                            </label>
                        </div>
                        <div class="col-md-6 col-sm-12 pr-md-50">
                            <input
                                class="custom-option-item-check"
                                type="radio"
                                name="credit-monitoring-services"
                                id="myfreescorenow"
                                v-model="defaultCreditMonitoringAgency"
                                :value="reportStore.myfreescorenow"
                            />
                            <label
                                class="custom-option-item text-center p-1 bg-transparent border rounded h-100"
                                :class="{ 'border-primary': defaultCreditMonitoringAgency == reportStore.myfreescorenow }"
                                for="myfreescorenow"
                            >
                                <img
                                    :src="creditMonitoringAgency(reportStore.myfreescorenow).icon"
                                    :alt="creditMonitoringAgency(reportStore.myfreescorenow).name"
                                />
                                <p>
                                    {{ defaultCreditMonitoringAgency == reportStore.myfreescorenow ? 'Selected' : 'Select this Option' }}
                                </p>
                            </label>
                        </div>
                        <div class="col-md-6 col-sm-12 pl-1 pl-md-0">
                            <input
                                class="custom-option-item-check"
                                type="radio"
                                name="credit-monitoring-services"
                                id="identityiq"
                                v-model="defaultCreditMonitoringAgency"
                                :value="reportStore.identityiq"
                            />
                            <label
                                class="custom-option-item text-center p-1 bg-transparent border rounded h-100"
                                :class="{ 'border-primary': defaultCreditMonitoringAgency == reportStore.identityiq }"
                                for="identityiq"
                            >
                                <img
                                    :src="creditMonitoringAgency(reportStore.identityiq).icon"
                                    :alt="creditMonitoringAgency(reportStore.identityiq).name"
                                />
                                <p>
                                    {{ defaultCreditMonitoringAgency == reportStore.identityiq ? 'Selected' : 'Select this Option' }}
                                </p>
                            </label>
                        </div>
                        <div class="col-md-6 col-sm-12 pr-md-50">
                            <input
                                class="custom-option-item-check"
                                type="radio"
                                name="credit-monitoring-services"
                                id="myscoreiq"
                                v-model="defaultCreditMonitoringAgency"
                                :value="reportStore.myscoreiq"
                            />
                            <label
                                class="custom-option-item text-center p-1 bg-transparent border rounded h-100"
                                for="myscoreiq"
                                :class="{ 'border-primary': defaultCreditMonitoringAgency == reportStore.myscoreiq }"
                            >
                                <img
                                    :src="creditMonitoringAgency(reportStore.myscoreiq).icon"
                                    :alt="creditMonitoringAgency(reportStore.myscoreiq).name"
                                />
                                <p>
                                    {{ defaultCreditMonitoringAgency == reportStore.myscoreiq ? 'Selected' : 'Select this Option' }}
                                </p>
                            </label>
                        </div>
                        
                    </div>
                    <div class="row gy-1 gx-2 mt-75">
                        <div class="col-12 text-center">
                            <button @click="updateCreditMonitoringAgency" type="button" class="btn btn-primary mr-1 mt-1">
                                Save
                            </button>
                            <button @click="closeModal('#' + id)" type="reset" class="btn btn-outline-secondary mt-1" aria-label="Close">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { defineComponent, ref, onBeforeMount } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { closeModal } from '../../utilities/_helpers'

    export default defineComponent({
        name: 'CreditMonitoringAgenciesModal',
        props: {
            id: String,
        },
        components: {
        },
        setup(props) {
            const reportStore = useReportStore(),
            userStore = useUserStore();
            return {
                localizationStore: useLocalizationStore(),
                reportStore: reportStore,
                userStore: userStore,
                closeModal: closeModal,
                defaultCreditMonitoringAgency: ref(null)
            }
        },
        mounted() {
            this.defaultCreditMonitoringAgency = this.userStore.user.defaultCreditMonitoringAgency;
        },
        watch: {
            'userStore.user.defaultCreditMonitoringAgency'(value) {
                this.defaultCreditMonitoringAgency = value;
            },
        },
        created() {
        },
        methods: {
            updateCreditMonitoringAgency() {
                const route = this.$router.resolve(
                    {
                        name:'update-credit-monitoring-agency',
                        params: {
                            client: this.$route.params.client,
                            team: this.$route.params.team
                        }
                    }
                ),
                $this = this;
                axios.post(
                    route.href,
                    {
                        credit_monitoring_agency: $this.defaultCreditMonitoringAgency
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    $this.userStore.user.defaultCreditMonitoringAgency = $this.defaultCreditMonitoringAgency;
                    $this.closeModal('#' + $this.id);
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            creditMonitoringAgency(agency) {
                return this.reportStore.creditMonitoringAgencies[agency];
            }
        }
    });
</script>
